// eslint-disable-next-line no-shadow
export enum Currency {
    RUB = 'RUB',
    EUR = 'EUR',
    USD = 'USD',
}
